import Vue from 'vue'
import { Config } from '@/services/ConfigService'
import * as SentryVue from '@sentry/vue'
import { router } from '@/router'

if (Config.VUE_APP_SENTRY_ENABLE) {
	const initOptions = {
		Vue,
		// Core options
		dsn: Config.VUE_APP_SENTRY_DSN,
		debug: Config.VUE_APP_SENTRY_DEBUG_ENABLE,
		release: process.env.FRONTEND_RELEASE,
		environment: Config.VUE_APP_MODE,
		sendDefaultPii: true,
		attachStacktrace: true,
		enableLogs: false,
		initialScope: {
			tags: {
				'workspace-domain': window.location.hostname
			}
		},
		sendClientReports: true,
		integrations: [SentryVue.dedupeIntegration()],

		// Error monitoring options
		sampleRate: Config.VUE_APP_SENTRY_SAMPLE_RATE,
		ignoreErrors: Config.VUE_APP_SENTRY_IGNORE_ERRORS,
		attachProps: Config.VUE_APP_SENTRY_ATTACH_PROPS_ENABLE,

		// Logs options
		logErrors: Config.VUE_APP_SENTRY_LOG_ERRORS
	}

	if (Config.VUE_APP_SENTRY_BROWSER_PROFILING_ENABLE) {
		initOptions.profileSessionSampleRate = Config.VUE_APP_SENTRY_PROFILE_SESSION_SAMPLE_RATE
		initOptions.profileLifecycle = 'trace'
		//initOptions.profileSampleRate = Config.VUE_APP_SENTRY_PROFILE_SAMPLE_RATE
		initOptions.integrations.push(SentryVue.browserProfilingIntegration())
	}

	if (Config.VUE_APP_SENTRY_FEEDBACK_ENABLE) {
		initOptions.integrations.push(
			SentryVue.feedbackIntegration({
				autoInject: true,
				showBranding: false,
				colorScheme: 'system',
				showName: true,
				showEmail: true,
				enableScreenshot: true,
				isNameRequired: true,
				isEmailRequired: true
			})
		)
	}

	if (Config.VUE_APP_SENTRY_BROWSER_TRACING_ENABLE) {
		initOptions.tracesSampleRate = Config.VUE_APP_SENTRY_TRACE_SAMPLE_RATE
		initOptions.trackComponents = true
		initOptions.hooks = Config.VUE_APP_SENTRY_HOOKS.split(',')
		initOptions.integrations.push(
			SentryVue.browserTracingIntegration({
				router: router,
				enableInp: true,
				interactionsSampleRate: Config.VUE_APP_SENTRY_INP_SAMPLE_RATE,
				tracePropagationTargets: [Config.VUE_APP_ROOT_API]
			})
		)
	}

	if (Config.VUE_APP_SENTRY_CAPTURE_CONSOLE_ENABLE) {
		initOptions.integrations.push(
			SentryVue.captureConsoleIntegration({
				levels: ['warn', 'error']
			})
		)
	}

	if (Config.VUE_APP_SENTRY_EXTRA_ERROR_DATA_ENABLE) {
		initOptions.integrations.push(
			SentryVue.extraErrorDataIntegration({
				depth: 3,
				captureErrorCause: true
			})
		)
	}

	if (Config.VUE_APP_SENTRY_REPORTING_OBSERVER_ENABLE) {
		initOptions.integrations.push(
			SentryVue.reportingObserverIntegration({
				types: ['crash', 'deprecation', 'intervention', 'default']
			})
		)
	}

	if (Config.VUE_APP_SENTRY_REPLAY_ENABLE) {
		initOptions.replaysSessionSampleRate = Config.VUE_APP_SENTRY_REPLAY_SESSION_SAMPLE_RATE
		initOptions.replaysOnErrorSampleRate = Config.VUE_APP_SENTRY_REPLAY_ERROR_SAMPLE_RATE
		initOptions.integrations.push(
			SentryVue.replayIntegration({
				// Text masking (default: true)
				maskAllText: false,
				// Block images/videos (default: true)
				blockAllMedia: false,
				// Mask specific inputs
				maskAllInputs: false
			})
		)
		if (Config.VUE_APP_SENTRY_REPLAY_CANVAS_ENABLE) {
			initOptions.integrations.push(
				SentryVue.replayCanvasIntegration({
					enableManualSnapshot: true,
					skipRequestAnimationFrame: true
				})
			)
		}
	}

	SentryVue.init(initOptions)
}
